import {Box, Button, Divider, Link, Skeleton, Typography} from '@mui/material';
import axios from 'axios';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useLoaderData, useLocation} from 'react-router-dom';
import HeaderWithIcons from '@components/app/HeaderWithIcons';
import {ICompetition, ICompetitionCategory} from './CultureInterface';
import {appConfig} from '@config';

export default function CultureCompetition() {
	const {t} = useTranslation();
	const location = useLocation();
	const [competitionCategory, setCompetitionCateogry] = useState<ICompetitionCategory | undefined>(location.state);
	let competitions = useLoaderData() as ICompetition[];
	const renderAction = (competition: ICompetition) => {
		let status = <Button component={Link} href={competition.winnerLink} className="mx-3">{t('winner_list')}</Button>;
		switch (competition.status) {
			case 'enabled':
				status = <Button component={Link} href={competition.link} className="mx-3">{t('start_competition')}</Button>;
				break;
			case 'remain':
				status = <Typography sx={{color: 'grey.600'}}
				                     className="mx-4">{t('remain_until_start', {day: competition.remainDay})}</Typography>;
		}
		return status;
	};
	return (
		<>
			<HeaderWithIcons title={competitionCategory?.name ?? <Skeleton className="w-24"/>}/>
			<Box className="rounded border flex flex-col mx-4" sx={{
				borderColor: (theme) => theme.palette.mode === 'light' ? 'grey.100' : 'background.paper',
				bgcolor: (theme) => theme.palette.mode === 'light' ? 'secondary.A200' : 'grey.700'
			}}>
				{
					competitions ?
						competitions.map((competition, index) => <Box key={competition.id}>
							<Box sx={{
								bgcolor: (theme) => theme.palette.mode === 'light' ? (competition.status === 'enabled' ? 'secondary.50' : '') : (competition.status === 'enabled' ? '#272931' : '')
							}} className="flex flex-row items-center h-11">
								<Typography sx={{color: 'grey.300'}} className="w-8 text-center h-fit">{index + 1}</Typography>
								<Typography
									sx={{color: (theme) => competition.status === 'remain' ? 'grey.400' : (theme.palette.mode === 'light' ? 'grey.800' : 'grey.100')}}
									className="grow h-fit">{competition.name}</Typography>
								{
									renderAction(competition)
								}
							</Box>
							{
								index + 1 !== competitions.length && <Divider/>
							}
						</Box>)
						:
						''
				}
			</Box>
		</>
	);
}

interface loader {
	request: Request;
	params: {};
}

export async function competitionsLoader(data: loader) {
	const res = await axios({
		// @ts-ignore
		url: `${appConfig.competition.url}competitions/${data.params.categoryId}`,
		method: 'GET'
	});
	if (res.data.success) {
		return res.data.result;
	} else {
		return res.data.error;
	}
}
